import { ClosestPickupPoint } from "../../../react4xp/parts/closest-pickup-point/closest-pickup-point";

export default (props) => <ClosestPickupPoint {...props} />
